/* eslint-disable */
import {
  Badge,
  HStack,
  IconButton,
  Stack,
  Switch,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import * as React from "react";
// Custom components

// Assets

import { createColumnHelper } from "@tanstack/react-table";
import { useDispatch, useSelector } from "react-redux";
import {
  selectButtonLoading,
  selectList,
  selectLoading,
  selectOrderBy,
  selectOrderDir,
  selectPageNo,
  selectPageSize,
  selectSearch,
  selectTotalRow,
} from "./redux/selector";

import { EditIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DateFormat from "../../../components/Common/DateFormat";
import { CommonTable } from "../../../components/CommonTable";
import { DataImportantStatusEnum, ENUM_USER_STATUS } from "../user/types";
import { actions } from "./redux/slice";
import { IData } from "./types";

export default function Index() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const search = useSelector(selectSearch);
  const tableData = useSelector(selectList);
  const loading = useSelector(selectLoading);
  const total = useSelector(selectTotalRow);
  const orderBy = useSelector(selectOrderBy);
  const orderDir = useSelector(selectOrderDir);
  const buttonLoading = useSelector(selectButtonLoading);
  const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);

  React.useEffect(() => {
    dispatch(actions.doGetList());
    return () => {};
  }, [pageNo, pageSize, search, orderDir, orderBy]);

  const handleUpdateStatus = (id: string, index: number) => {
    setSelectedIndex(index);
    dispatch(
      actions.doUpdateStatus({
        id: id,
        index: index,
        callback() {
          setSelectedIndex(null);
          dispatch(actions.doGetList());
        },
      })
    );
  };

  const handleIImportantStatus = (id: string, index: number) => {
    setSelectedIndex(index);
    dispatch(
      actions.doUpdateImportant({
        id: id,
        index: index,
        callback() {
          setSelectedIndex(null);
          dispatch(actions.doGetList());
        },
      })
    );
  };

  const columnHelper = createColumnHelper<IData>();
  const columns = [
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.sNo")}`,
      cell: (info) => {
        return (
          <>
            {pageNo === 1 ? (
              <>{info.row.index + 1}</>
            ) : (
              <>{`${(pageNo - 1) * pageSize + info.row.index + 1}`}</>
            )}
          </>
        );
      },
    }),
    columnHelper.accessor("firstName", {
      id: "firstName",
      header: `${t("common.list.fullName")}`,
      cell: (info) => (
        <Text>
          {info.row.original.lastName + " " + info.getValue() || "NA"}
        </Text>
      ),
    }),
    columnHelper.accessor("japaneseFirstName", {
      id: "japaneseFirstName",
      header: `${t("common.list.JapaneseFullName")}`,
      cell: (info) => (
        <Text>
          {info.row.original.japaneseLastName + " " + info.getValue() || "NA"}
        </Text>
      ),
    }),
    columnHelper.accessor("email", {
      id: "email",
      header: `${t("common.list.email")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    columnHelper.accessor("mobileNumber", {
      id: "mobileNumber",
      header: `${t("common.list.mobileNumber")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    columnHelper.accessor("customerId", {
      id: "customerId",
      header: `${t("common.list.customerId")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    columnHelper.accessor("importantStatus", {
      id: "importantStatus",
      header: `${t("common.list.importantStatus")}`,
      cell: (info) => (
        <Badge
          colorScheme={
            info.getValue() === DataImportantStatusEnum.IMPORTANT
              ? "green"
              : "red"
          }
          color={
            info.getValue() === DataImportantStatusEnum.IMPORTANT
              ? "green.500"
              : "red.500"
          }
          fontSize="md"
          fontWeight="500"
          sx={{ textTransform: "capitalCase" }}
        >
          <Text sx={{ textTransform: "capitalCase" }}>
            {info.getValue() === DataImportantStatusEnum.IMPORTANT
              ? "Important"
              : info.getValue() === DataImportantStatusEnum.NOT_IMPORTANT
              ? "Not Important"
              : ""}
          </Text>
        </Badge>
      ),
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: `${t("common.list.status")}`,
      cell: (info) => (
        <Badge
          colorScheme={
            info.getValue() === ENUM_USER_STATUS.ACTIVE ? "green" : "red"
          }
          color={
            info.getValue() === ENUM_USER_STATUS.ACTIVE
              ? "green.500"
              : "red.500"
          }
          fontSize="md"
          fontWeight="500"
          sx={{ textTransform: "capitalCase" }}
        >
          <Text sx={{ textTransform: "capitalCase" }}>
            {info.getValue() === ENUM_USER_STATUS.ACTIVE
              ? "Active"
              : info.getValue() === ENUM_USER_STATUS.INACTIVE
              ? "In-active"
              : info.getValue() === ENUM_USER_STATUS.DELETED
              ? "Delete"
              : ""}
          </Text>
        </Badge>
      ),
    }),

    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: `${t("common.list.createdAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
       sortDescFirst: true,
    }),
    columnHelper.accessor("updatedAt", {
      id: "updatedAt",
      header: `${t("common.list.updatedAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: `${t("common.list.updateStatus")}`,

      cell: (info) => (
        <Stack>
          <Switch
            disabled={info.row.index === selectedIndex && buttonLoading}
            colorScheme={
              info.getValue() === ENUM_USER_STATUS.ACTIVE ? "green" : "yellow"
            }
            color={
              info.getValue() === ENUM_USER_STATUS.ACTIVE
                ? "green.500"
                : "red.500"
            }
            checked={
              info.row.original.status == ENUM_USER_STATUS.ACTIVE ? true : false
            }
            defaultChecked={
              info?.row?.original?.status == ENUM_USER_STATUS.ACTIVE
                ? true
                : false
            }
            onChange={() => {
              handleUpdateStatus(info.row.original._id, info.row.index);
            }}
          />
        </Stack>
      ),
    }),
    columnHelper.accessor("importantStatus", {
      id: "importantStatus",
      header: `${t("common.list.updateImportantStatus")}`,

      cell: (info) => (
        <Stack>
          <Switch
            disabled={info.row.index === selectedIndex && buttonLoading}
            colorScheme={
              info.getValue() === DataImportantStatusEnum.IMPORTANT
                ? "green"
                : "yellow"
            }
            color={
              info.getValue() === DataImportantStatusEnum.IMPORTANT
                ? "green.500"
                : "red.500"
            }
            checked={
              info.row.original.importantStatus ==
              DataImportantStatusEnum.IMPORTANT
                ? true
                : false
            }
            defaultChecked={
              info?.row?.original?.importantStatus ==
              DataImportantStatusEnum.IMPORTANT
                ? true
                : false
            }
            onChange={() => {
              handleIImportantStatus(info.row.original._id, info.row.index);
            }}
          />
        </Stack>
      ),
    }),
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.actions")}`,
      cell: (info) => {
        return (
          <HStack>
            <Tooltip label={`${t("common.list.edit")}`}>
              <IconButton
                aria-label="Edit"
                icon={<EditIcon />}
                onClick={() => {
                  navigate(`/admin/retailer/create/${info.row.original._id}`);
                }}
              />
            </Tooltip>
          </HStack>
        );
      },
    }),
  ];
  return (
    <>
      <CommonTable<IData>
        columns={columns}
        data={tableData}
        totalCount={total}
        pageNo={pageNo}
        pageSize={pageSize}
        search={search}
        loading={loading}
        onSearch={(v) => dispatch(actions.setSearch(v))}
        onPageChange={(p) => dispatch(actions.setPageNo(p))}
        onPageSizeChange={(s) => dispatch(actions.setPageSize(s))}
        onSortChange={(id, desc) => {
          dispatch(actions.setOrderBy(id));
          dispatch(actions.setOrderDir(desc ? "desc" : "asc"));
        }}
        hideAddButton
      />
    </>
  );
}
